export default {
  ScheduledJob: 'ScheduledJob',
  ScheduledReport: 'ScheduledReport',
}
